<template>
  <div class="rootDiv">
    <div class="borderDiv">
      <div>
        <Span style="font-size: 1.2rem">教育类</Span>
      </div>
      <div>
        <div class="unitDiv" @click="historyEvents">
          <img src="../../../assets/images/64/history_event.png" width="64" height="64" alt="">
          <br/>
          <Span>历史上的今天</Span>
        </div>
        <div class="unitDiv" @click="Contry">
          <img src="../../../assets/images/64/nation.png" width="64" height="64" alt="">
          <br/>
          <Span>世界各国</Span>
        </div>
        <div class="unitDiv" @click="TangshiSongci">
          <img src="../../../assets/images/64/tangshisongci.png" width="64" height="64" alt="">
          <br/>
          <Span>唐诗宋词元曲</Span>
        </div>
        <div class="unitDiv" @click="Region">
          <img src="../../../assets/images/64/region.png" width="64" height="64" alt="">
          <br/>
          <Span>全国行政区划</Span>
        </div>
      </div>
    </div>
    <div class="borderDiv">
      <div>
        <Span style="font-size: 1.2rem">出行类</Span>
      </div>
      <div>
        <div class="unitDiv" @click="licensePlate">
          <img src="../../../assets/images/64/car_number.png" width="64" height="64" alt="">
          <br/>
          <Span>车牌简称</Span>
        </div>
        <div class="unitDiv" @click="Airport">
          <img src="../../../assets/images/64/airport.png" width="64" height="64" alt="">
          <br/>
          <Span>国内机场</Span>
        </div>
        <div class="unitDiv" @click="Hotel">
          <img src="../../../assets/images/64/hotel.png" width="64" height="64" alt="">
          <br/>
          <Span>全国5星级酒店</Span>
        </div>
        <div class="unitDiv" @click="GoToView">
          <img src="../../../assets/images/64/view.png" width="64" height="64" alt="">
          <br/>
          <Span>全国5A景区</Span>
        </div>
      </div>
    </div>
    <div class="borderDiv">
      <div>
        <Span style="font-size: 1.2rem">生活类</Span>
      </div>
      <div>
        <div class="unitDiv" @click="recipe">
          <img src="../../../assets/images/64/recipe.png" width="64" height="64" alt="">
          <br/>
          <Span>菜谱大全</Span>
        </div>
        <div class="unitDiv" @click="dateTool">
          <img src="../../../assets/images/64/calculation.png" width="64" height="64" alt="">
          <br/>
          <Span>日期计算</Span>
        </div>
        <div class="unitDiv" @click="BirthdayHoliday">
          <img src="../../../assets/images/64/calendar.png" width="64" height="64" alt="">
          <br/>
          <Span>生日与节日</Span>
        </div>
        <div class="unitDiv" @click="Village">
          <img src="../../../assets/images/64/village.png" width="64" height="64" alt="">
          <br/>
          <Span>全国村镇信息</Span>
        </div>
      </div>
    </div>
    <div class="borderDiv">
      <div>
        <Span style="font-size: 1.2rem">娱乐类</Span>
      </div>
      <div>
        <div class="unitDiv" @click="douyinTool">
          <img src="../../../assets/images/64/douyin.png" width="64" height="64" alt="">
          <br/>
          <Span>抖音去水印</Span>
        </div>
        <div class="unitDiv" @click="StarBirthday">
          <img src="../../../assets/images/64/StarBirthday.png" width="64" height="64" alt="">
          <br/>
          <Span>明星数据库</Span>
        </div>
        <div class="unitDiv" @click="GoToJoke">
          <img src="../../../assets/images/64/joker.png" width="64" height="64" alt="">
          <br/>
          <Span>笑话大全</Span>
        </div>
        <div class="unitDiv" @click="GoFishing">
          <img src="../../../assets/images/64/fishing.png" width="64" height="64" alt="">
          <br/>
          <Span>钓鱼圈</Span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LifeTool",
  methods: {
    Region() {
      this.$router.push('m_region')
    },
    Village() {
      this.$router.push('m_village')
    },
    TangshiSongci() {
      this.$router.push('m_tangshi_songci')
    },
    StarBirthday() {
      this.$router.push('m_star_main')
    },
    GoToView() {
      this.$router.push('m_view_group')
    },
    GoFishing() {
      this.$router.push('m_fishing_main')
    },
    GoToJoke() {
      this.$router.push('m_joke')
    },
    BirthdayHoliday() {
      this.$router.push('m_birthday_holiday')
    },
    douyinTool() {
      this.$router.push('m_douyin_tool')
    },
    recipe() {
      this.$router.push('m_recipe')
    },
    historyEvents() {
      let date = new Date();
      let year = date.getFullYear().toString()
      let month = (date.getMonth() + 1).toString();
      let day = date.getDate().toString();
      localStorage.setItem('showCondition', '1')
      this.$router.push({name: 'm_historical_event', params: {year: year, month: month, day: day}})
    },
    Hotel() {
      this.$router.push('m_hotel')
    },
    Airport() {
      this.$router.push('m_airport')
    },
    licensePlate() {
      this.$router.push('m_license_plate')
    },
    dateTool() {
      this.$router.push('m_date_tool')
    },
    Contry() {
      this.$router.push('m_contry_list')
    },
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#EDEDED')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  background-color: transparent;
  overflow: auto;
  margin-bottom: 50px;
}

.borderDiv {
  border: solid 0.1rem white;
  border-radius: 0.5rem;
  background-color: white;
  clear: both;
  padding-top: 0.5rem;
  margin-bottom: 1rem;
  overflow: auto;
}

.unitDiv {
  float: left;
  width: 20%;
  font-size: 0.8rem;
  margin: 0.5rem;
  border-radius: 0.5rem;
  overflow: auto;

  Span {
    font-size: 0.9rem;
  }
}
</style>
